import {useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import {useParams} from 'react-router-dom'
import clubStore from '../../../storage/ClubStore'
import BillingDetail from '../ParentMember/BillingDetail'

const MemberBillingPay = () => {
  const {id} = useParams()
  const child = clubStore.child

  useEffect(() => {
    child.reset_billing_detail()
    if (id) child.getBillingDetail(id)
    return () => child.reset_billing_detail()
  }, [id])

  return <BillingDetail back_url="/member/billing" store={child}/>
}

export default observer(MemberBillingPay)